<template>
  <header>
    <div class="logo">
      <router-link to="/"><img src="/assets/logo.svg"></router-link>
    </div>
    <div class="header">
      <slot name="header"></slot>
    </div>
    <div class="accounts">

      <template v-if="me">
        <div class="navigations">
          <slot name="controls"></slot>
          <div class="appHistories">
            <template v-if="appHistory" v-for="v in appHistory">
              <router-link v-if="v.path !== ''" class="appHistory" :to="{ name: 'Play', params: { app: v.path }}"><img :src="util.variant(v.icon, 'w=128,format=webp')" /></router-link>
            </template>
          </div>
          <router-link :to="{ name: 'Account' }" class="account" :title="me.email + ' ウォレット残高：' + me.total.toLocaleString() + '円'"><i class="fa-regular fa-user"></i></router-link>
        </div>
      </template>

      <template v-if="me === false">
        <div class="navigations">
          <slot name="controls"></slot>
          <div class="register" v-if="register !== false">
            <router-link to="/register" class="portraitHidden">登録してゲームの続きを保存</router-link>
            <router-link to="/register" class="portraitShowFlex">新規登録</router-link>
          </div>
          <a href="javascript:;" class="login" @click="showLoginModal()">ログイン</a>
        </div>
      </template>

    </div>
  </header>
  <slot name="left">
  </slot>
  <main :class="main" :style="mainStyle">
    <slot></slot>
  </main>
  <footer>
    <a href="https://corporate.tapfun.co.jp/" target="_blank">TapFunについて</a>
    <a href="https://corporate.tapfun.co.jp/basic" target="_blank">特商法に基づく表示</a>
    <a href="https://corporate.tapfun.co.jp/terms" target="_blank">利用規約</a>
    <a href="https://corporate.tapfun.co.jp/company" target="_blank">運営会社</a>
    <a href="https://corporate.tapfun.co.jp/for_publishers" target="_blank">ゲーム会社の方</a>
    <a href="https://corporate.tapfun.co.jp/for_investors" target="_blank">投資家の方</a>
  </footer>
  <slot name="modals"></slot>
  <Modal v-model="loginModal" :title="title" :modalClass="['loginModal']">
    <div v-if="me">
      <div class="mt-2 mb-4 text-center">
        「<strong>{{ me.email }}</strong>」でTapFunにログインしました。
      </div>
      <div class="">
        <button class="btn btn-dark w-100" @click="loginModal = false">OK</button>
      </div>
    </div>
    <div v-else>
      <div class="mt-1 mb-3 text-center">
        <button class="gsi-material-button" @click.prevent="google()">
          <div class="gsi-material-button-state"></div>
          <div class="gsi-material-button-content-wrapper">
            <div class="gsi-material-button-icon">
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
                <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                <path fill="none" d="M0 0h48v48H0z"></path>
              </svg>
            </div>
            <span class="gsi-material-button-contents" style="font-weight: 700; color: #525252">Google アカウントでログイン</span>
            <span style="display: none;">Sign in with Google</span>
          </div>
        </button>
      </div>
      <form @submit.prevent="loginSubmit()">
        <hr class="mb-3 w-100" />
        <div class="mb-3">
          <label for="loginEmail" class="form-label">メールアドレス</label>
          <input type="email" class="form-control" :class="{'is-invalid': loginError && !loginAccountExists}" id="loginEmail" ref="loginEmail" v-model="loginEmail" placeholder="address@example.com" required />
          <div class="invalid-feedback" v-if="!loginAccountExists">
            {{ loginErrorMessage }}
          </div>
        </div>
        <div class="mb-3">
          <label for="loginPassword" class="form-label">パスワード</label>
          <input type="password" class="form-control" :class="{'is-invalid': loginError && loginAccountExists}" id="loginPassword" ref="loginPassword" v-model="loginPassword" placeholder="パスワード" required />
          <div class="invalid-feedback" v-if="loginAccountExists">
            {{ loginErrorMessage }}。<a href="javascript:;" @click.prevent="loginModal = false; passwordReminderModal = true">再設定する</a>
          </div>
        </div>
        <div class="mb-3">
          <button type="submit" class="btn btn-danger btn-lg fw-bold w-100">ログイン</button>
        </div>
        <div class="footer">
          <div class="register">
            <div>
              <router-link @click="loginModal = false" to="/register">新規登録</router-link>
              |
              <a href="javascript:;" @click.prevent="loginModal = false; passwordReminderModal = true">パスワードを忘れました</a>
            </div>
          </div>
        </div>
      </form>
    </div>
  </Modal>
  <Modal v-model="passwordReminderModal" title="パスワードの再設定">
    <form @submit.prevent="passwordReminderSubmit()">
      <div class="mb-3">
        <label for="reminderEmail" class="form-label">メールアドレス</label>
        <input type="email" class="form-control" :class="{'is-invalid': passwordReminderError}" id="reminderEmail" ref="reminderEmail" v-model="loginEmail" placeholder="address@example.com" required />
        <div class="invalid-feedback">
          アカウントが見つかりませんでした。
        </div>
      </div>
      <div class="mb-3">
        <button type="submit" class="btn btn-danger btn-lg fw-bold w-100">再設定メールを送信</button>
      </div>
      <div class="mb-3" v-if="passwordReminderSubmited">
        <div class="alert alert-success">
          パスワードの再設定メールを送信しました。メールを確認してリンクを開いてください。
        </div>
      </div>
      <div class="">
        <router-link to="/register">新規登録</router-link>
        |
        <a href="javascript:;" @click="passwordReminderModal = false; loginModal = true">ログイン</a>
      </div>
    </form>
  </Modal>
  <Modal v-model="linkedModal" title="Google ログイン連携を行いました">
    <div class="text-center">
      <div class="mb-3">
        <div class="alert alert-success">
          <p>選択した Google アカウントの「{{ me.email }}」を同じメールアドレスのTapFunアカウントに連携してログインしました。</p>
          <p class="text-center mb-0">
            <router-link class="text-decoration-underline" :to="{ name: 'Google' }">Google ログイン連携設定を確認する</router-link>
          </p>
        </div>
      </div>
      <div>
        <button type="button" class="btn btn-dark" @click.prevent="linkedModal = false">閉じる</button>
      </div>
    </div>
  </Modal>
  <Modal v-model="registeredModal" title="TapFun アカウントを作成しました">
    <div class="text-center">
      <div class="mb-3">
        <div class="alert alert-success">
          <p>選択した Google アカウントの「{{ me.email }}」を同じメールアドレスのTapFunアカウントとして作成しました。</p>
          <p>今後は、この Google アカウントでログインすることができます。</p>
          <p class="text-center mb-0">
            <router-link class="text-decoration-underline" :to="{ name: 'Google' }">Google ログイン連携設定を確認する</router-link>
          </p>
        </div>
      </div>
      <div>
        <button type="button" class="btn btn-dark" @click.prevent="registeredModal = false">閉じる</button>
      </div>
    </div>
  </Modal>
  <LoadingOverlay :active="loadingOverlay || logining" :is-full-page="fullPage" loader="bars" color="#f58300" background-color="#000" width="128" height="128">
    <slot name="loading"></slot>
  </LoadingOverlay>
    
</template>

<script>
import { nextTick } from 'vue';
import { toast } from 'vue3-toastify';

export default {
  mixins: [
  ],
  components: {
  },
  props: [
    'register',
    'main',
    'mainStyle',
    'me',
    'loadingOverlay',
    'lastApp',
    'appHistory',
    'googleContext',
  ],
  data () {
    return {
      config: require('../../lib/config'),
      util: require('../../lib/util'),
      title: 'TapFunにログイン',
      logining: false,
      loginModal: this.$route.query.loginModal ? true : false,
      loginEmail: '',
      loginPassword: '',
      loginError: null,
      loginAccountExists: false,
      passwordReminderModal: false,
      passwordReminderSubmited: false,
      passwordReminderError: false,
      linkedModal: false,
      registeredModal: false,
    };
  },
  created() {
    document.querySelector('body').className = this.main ?? '';
  },
  computed: {
    loginErrorMessage() {
      return this.loginAccountExists ? 'パスワードが間違っています' : 'アカウントが見つかりませんでした';
    },
  },
  methods: {
    _flash(flash) {
      console.log({ flash });
      if (flash.type == 'linked') {
        this.linkedModal = true;
      }
      if (flash.type == 'registered') {
        this.registeredModal = true;
      }
      if (flash.type == 'toast') {
        console.log('toast', flash.message);
        toast(flash.message, {
          type: 'success',
          transition: 'slide',
          hideProgressBar: true,
          position: 'top-center',
          autoClose: 2000,
          ...flash.toast,
        });
      }
    },
    showLoginModal(title) {
      this.title = title || 'TapFunにログイン';
      this.loginModal = true;
      nextTick(() => {
        setTimeout(() => {
          this.$refs.loginEmail.focus();
        }, 100);
      });
    },
    loginSubmit() {
      const data = {};
      data.email = this.loginEmail;
      data.password = this.loginPassword;
      this.loginError = null;
      this.logining = true;
      this.axios({
        method: 'post',
        url: '/login',
        data: data,
      }).then((r) => {
        if (r.data.p) {
          location.reload();
          return;
        }
        this.loginAccountExists = r.data.exists;
        this.loginError = true;
        this.logining = false;
        nextTick(() => {
          setTimeout(() => {
            if (this.loginAccountExists) {
              this.$refs.loginPassword.focus();
              return;
            }
            this.$refs.loginEmail.focus();
          }, 100);
        });
      }).catch((e) => {
        alert('error');
        this.logining = false;
      });
    },
    passwordReminderSubmit() {
      const data = {};
      data.email = this.loginEmail;
      this.logining = true;
      this.passwordReminderSubmited = false;
      this.axios({
        method: 'post',
        url: '/reminder',
        data: data,
      }).then((r) => {
        this.logining = false;
        if (r.data.error) {
          this.passwordReminderError = true;
          this.logining = false;
          return;
        }
        this.passwordReminderError = false;
        this.passwordReminderSubmited = true;
      }).catch((e) => {
        alert('server error');
        this.logining = false;
      });
    },
    google() {
      const context = this.googleContext || 'header';
      location.href = '/player/login/google?context=' + context;
      return false;
    },
  },
}
</script>
